import { useTranslation } from 'react-i18next';

export const useDevicesTranslation = () => useTranslation('devices');
